// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"fdcce930","787":"7e013472"}[chunkId] + ".chunk.js";
};